var map = {
	"./alert.svg": [
		28272,
		28272
	],
	"./filled/Credito_automatico.svg": [
		33954,
		33954
	],
	"./filled/Credito_consignado.svg": [
		47057,
		47057
	],
	"./filled/Credito_imobiliario.svg": [
		29137,
		29137
	],
	"./filled/Itoken.svg": [
		34193,
		34193
	],
	"./filled/Viagem.svg": [
		58609,
		58609
	],
	"./filled/acoes.svg": [
		95011,
		95011
	],
	"./filled/agencia-personalite.svg": [
		45709,
		45709
	],
	"./filled/agencia.svg": [
		21540,
		21540
	],
	"./filled/agil.svg": [
		24776,
		24776
	],
	"./filled/ajuda.svg": [
		25344,
		25344
	],
	"./filled/alimentacao.svg": [
		83609,
		83609
	],
	"./filled/alvo.svg": [
		62793,
		62793
	],
	"./filled/antecipacao_de_recebimento.svg": [
		69263,
		69263
	],
	"./filled/aplicativos.svg": [
		58546,
		58546
	],
	"./filled/aporte-de-capital.svg": [
		72099,
		72099
	],
	"./filled/ar_condicionado.svg": [
		85222,
		85222
	],
	"./filled/armario.svg": [
		11794,
		11794
	],
	"./filled/arroba.svg": [
		16063,
		16063
	],
	"./filled/atendimento.svg": [
		14616,
		14616
	],
	"./filled/atualizando.svg": [
		67342,
		67342
	],
	"./filled/autoriza-pelo-celular.svg": [
		95242,
		95242
	],
	"./filled/aviso.svg": [
		44180,
		44180
	],
	"./filled/balanco-de-caixa.svg": [
		51151,
		51151
	],
	"./filled/beleza.svg": [
		50911,
		50911
	],
	"./filled/beneficios.svg": [
		88279,
		88279
	],
	"./filled/bike.svg": [
		96100,
		96100
	],
	"./filled/biometria.svg": [
		19745,
		19745
	],
	"./filled/brilho-nos-olhos.svg": [
		61455,
		61455
	],
	"./filled/busca.svg": [
		1345,
		1345
	],
	"./filled/caixa-eletronico.svg": [
		36895,
		36895
	],
	"./filled/calendario.svg": [
		32818,
		32818
	],
	"./filled/carrinho.svg": [
		22293,
		22293
	],
	"./filled/cartao-de-seguranca.svg": [
		68881,
		68881
	],
	"./filled/cartao.svg": [
		30745,
		30745
	],
	"./filled/carteira-digital.svg": [
		36089,
		36089
	],
	"./filled/carteiras-digitais-full.svg": [
		5402,
		5402
	],
	"./filled/cartoes.svg": [
		2504,
		2504
	],
	"./filled/celular-pre-pago.svg": [
		6236,
		6236
	],
	"./filled/celular.svg": [
		11766,
		11766
	],
	"./filled/chat-aguardando.svg": [
		79868,
		79868
	],
	"./filled/chat-erro.svg": [
		21939,
		21939
	],
	"./filled/chave.svg": [
		56601,
		56601
	],
	"./filled/checkbox.svg": [
		80922,
		80922
	],
	"./filled/cheque.svg": [
		52931,
		52931
	],
	"./filled/chip.svg": [
		39410,
		39410
	],
	"./filled/cifrao.svg": [
		78122,
		78122
	],
	"./filled/cinema.svg": [
		95868,
		95868
	],
	"./filled/coleta.svg": [
		31212,
		31212
	],
	"./filled/compartilhar.svg": [
		22833,
		22833
	],
	"./filled/compra.svg": [
		64876,
		64876
	],
	"./filled/compras.svg": [
		58789,
		58789
	],
	"./filled/comprovante.svg": [
		76580,
		76580
	],
	"./filled/computador.svg": [
		33583,
		33583
	],
	"./filled/configuracao.svg": [
		16729,
		16729
	],
	"./filled/confirmacao.svg": [
		69726,
		69726
	],
	"./filled/cons-investimento.svg": [
		67679,
		67679
	],
	"./filled/consorcio-auto.svg": [
		87459,
		87459
	],
	"./filled/consorcio-imobiliario.svg": [
		79330,
		79330
	],
	"./filled/consorcio.svg": [
		4135,
		4135
	],
	"./filled/conta-corrente.svg": [
		72895,
		72895
	],
	"./filled/contatos.svg": [
		78153,
		78153
	],
	"./filled/copiar.svg": [
		31215,
		31215
	],
	"./filled/craques.svg": [
		35601,
		35601
	],
	"./filled/credito-auto.svg": [
		47289,
		47289
	],
	"./filled/credito-sob-medida.svg": [
		53397,
		53397
	],
	"./filled/credito.svg": [
		38756,
		38756
	],
	"./filled/csv.svg": [
		83827,
		83827
	],
	"./filled/cultura.svg": [
		32878,
		32878
	],
	"./filled/curtir.svg": [
		89709,
		89709
	],
	"./filled/debito.svg": [
		30448,
		30448
	],
	"./filled/desafios.svg": [
		56364,
		56364
	],
	"./filled/desbloqueio.svg": [
		51444,
		51444
	],
	"./filled/descurtir.svg": [
		88465,
		88465
	],
	"./filled/diario.svg": [
		77905,
		77905
	],
	"./filled/documento.svg": [
		33731,
		33731
	],
	"./filled/documentos-pasta.svg": [
		96972,
		96972
	],
	"./filled/download.svg": [
		86586,
		86586
	],
	"./filled/editar.svg": [
		83086,
		83086
	],
	"./filled/email-resposta-rapida.svg": [
		17676,
		17676
	],
	"./filled/empresa.svg": [
		81124,
		81124
	],
	"./filled/emprestimo.svg": [
		35183,
		35183
	],
	"./filled/enviar.svg": [
		55037,
		55037
	],
	"./filled/esporte.svg": [
		72240,
		72240
	],
	"./filled/excel.svg": [
		80894,
		80894
	],
	"./filled/excluir.svg": [
		63549,
		63549
	],
	"./filled/facebook.svg": [
		37221,
		37221
	],
	"./filled/fatura.svg": [
		33183,
		33183
	],
	"./filled/favorito.svg": [
		7229,
		7229
	],
	"./filled/feedback.svg": [
		4810,
		4810
	],
	"./filled/fingerprint.svg": [
		77901,
		77901
	],
	"./filled/flash-desabilitado.svg": [
		94068,
		94068
	],
	"./filled/flash-habilitado.svg": [
		61111,
		61111
	],
	"./filled/futebol.svg": [
		97413,
		97413
	],
	"./filled/garantia.svg": [
		31740,
		31740
	],
	"./filled/gerenciador-de-vendas.svg": [
		31871,
		31871
	],
	"./filled/gestao-de-crises.svg": [
		47493,
		47493
	],
	"./filled/globo.svg": [
		35911,
		35911
	],
	"./filled/historico-de-rentabilidade.svg": [
		38917,
		38917
	],
	"./filled/home.svg": [
		92686,
		92686
	],
	"./filled/impressora.svg": [
		16226,
		16226
	],
	"./filled/informacao.svg": [
		43010,
		19583
	],
	"./filled/inovacao.svg": [
		45476,
		45476
	],
	"./filled/instagram.svg": [
		29782,
		29782
	],
	"./filled/institucional.svg": [
		58552,
		58552
	],
	"./filled/investimento.svg": [
		55380,
		55380
	],
	"./filled/itaupass.svg": [
		29658,
		29658
	],
	"./filled/itoken-chaveiro.svg": [
		1049,
		1049
	],
	"./filled/jornal.svg": [
		26144,
		26144
	],
	"./filled/lavagem-de-dinheiro.svg": [
		1881,
		1881
	],
	"./filled/lideranca.svg": [
		898,
		44547
	],
	"./filled/limite.svg": [
		76131,
		76131
	],
	"./filled/link-externo.svg": [
		80440,
		80440
	],
	"./filled/logo-itau.svg": [
		63941
	],
	"./filled/logo-laranja.svg": [
		41426
	],
	"./filled/loja.svg": [
		50622,
		50622
	],
	"./filled/maiores-limites.svg": [
		91777,
		91777
	],
	"./filled/mala.svg": [
		4572,
		4572
	],
	"./filled/maquina-cartao.svg": [
		25246,
		25246
	],
	"./filled/maquina-fotografica.svg": [
		72011,
		72011
	],
	"./filled/maquina-pos.svg": [
		12713,
		12713
	],
	"./filled/maximizar.svg": [
		96825,
		96825
	],
	"./filled/metro.svg": [
		80044,
		80044
	],
	"./filled/microfone.svg": [
		89661,
		89661
	],
	"./filled/minimizar.svg": [
		62147,
		62147
	],
	"./filled/notificacao.svg": [
		94357,
		94357
	],
	"./filled/olho-ativo.svg": [
		42024,
		42024
	],
	"./filled/olho-inativo.svg": [
		48249,
		48249
	],
	"./filled/onibus.svg": [
		46749,
		46749
	],
	"./filled/orientador-de-credito.svg": [
		10241,
		10241
	],
	"./filled/pagamento-ao-fornecedor.svg": [
		63921,
		63921
	],
	"./filled/paixao.svg": [
		37507,
		37507
	],
	"./filled/parcelamento.svg": [
		45216,
		45216
	],
	"./filled/pdf.svg": [
		23702,
		23702
	],
	"./filled/perfil-do-investidor.svg": [
		30222,
		30222
	],
	"./filled/pers-conta.svg": [
		18270,
		18270
	],
	"./filled/pet.svg": [
		54166,
		54166
	],
	"./filled/pix-pix.svg": [
		94919,
		94919
	],
	"./filled/portabilidade.svg": [
		29576,
		29576
	],
	"./filled/poupanca.svg": [
		9175,
		9175
	],
	"./filled/premio.svg": [
		45301,
		45301
	],
	"./filled/presente.svg": [
		47097,
		47097
	],
	"./filled/prevencao-de-fraude.svg": [
		90130,
		27111
	],
	"./filled/previdencia.svg": [
		15963,
		15963
	],
	"./filled/processos.svg": [
		36303,
		36303
	],
	"./filled/programa-de-pontos.svg": [
		99491,
		99491
	],
	"./filled/proibido-fumar.svg": [
		91424,
		91424
	],
	"./filled/projeto-sucessorio.svg": [
		38964,
		38964
	],
	"./filled/radio-button.svg": [
		35171,
		35171
	],
	"./filled/radio.svg": [
		59510,
		59510
	],
	"./filled/relatorios-financeiros.svg": [
		83174,
		83174
	],
	"./filled/relogio.svg": [
		1616,
		1616
	],
	"./filled/responder.svg": [
		80315,
		80315
	],
	"./filled/responsabilidade-social.svg": [
		28356,
		28356
	],
	"./filled/restaurar.svg": [
		78607,
		78607
	],
	"./filled/salario.svg": [
		78540,
		78540
	],
	"./filled/saldo.svg": [
		71518,
		71518
	],
	"./filled/salvar.svg": [
		22381,
		22381
	],
	"./filled/saude.svg": [
		57687,
		57687
	],
	"./filled/seguranca-da-informacao.svg": [
		86057,
		86057
	],
	"./filled/seguranca-patrimonial.svg": [
		36542,
		36542
	],
	"./filled/seguranca-redes-sociais.svg": [
		38565,
		38565
	],
	"./filled/seguranca.svg": [
		26441,
		26441
	],
	"./filled/seguro-auto.svg": [
		39896,
		39896
	],
	"./filled/seguro-cartao.svg": [
		67221,
		67221
	],
	"./filled/seguro-crianca.svg": [
		12106,
		12106
	],
	"./filled/seguro-de-credito.svg": [
		46488,
		46488
	],
	"./filled/seguro-empresas.svg": [
		15574,
		15574
	],
	"./filled/seguro-fraude.svg": [
		59933,
		59933
	],
	"./filled/seguro-mulher.svg": [
		39676,
		39676
	],
	"./filled/seguro-patrimonial.svg": [
		54540,
		54540
	],
	"./filled/seguro-pet.svg": [
		58816,
		58816
	],
	"./filled/seguro-prestamista.svg": [
		56761,
		56761
	],
	"./filled/seguro-renda.svg": [
		66471,
		66471
	],
	"./filled/seguro-residencial.svg": [
		43734,
		43734
	],
	"./filled/seguro-responsabilidade-social.svg": [
		61243,
		61243
	],
	"./filled/seguro-transporte.svg": [
		36383,
		36383
	],
	"./filled/seguro-viagem.svg": [
		55710,
		55710
	],
	"./filled/seguro-vida.svg": [
		77671,
		77671
	],
	"./filled/seguro.svg": [
		56381,
		56381
	],
	"./filled/selecao-terceiros-full.svg": [
		91480,
		91480
	],
	"./filled/senha-circulo.svg": [
		16171,
		16171
	],
	"./filled/senha.svg": [
		26213,
		26213
	],
	"./filled/sms-chat.svg": [
		12190,
		12190
	],
	"./filled/sonho-grande.svg": [
		6833,
		6833
	],
	"./filled/sorriso.svg": [
		57750,
		57750
	],
	"./filled/suporte.svg": [
		27261,
		27261
	],
	"./filled/sustentabilidade.svg": [
		39745,
		39745
	],
	"./filled/switch.svg": [
		10349,
		10349
	],
	"./filled/tablet.svg": [
		47885,
		47885
	],
	"./filled/teatro.svg": [
		81979,
		81979
	],
	"./filled/telefone.svg": [
		21370,
		21370
	],
	"./filled/timeline.svg": [
		44212,
		44212
	],
	"./filled/todos-pelo-cliente.svg": [
		83166,
		83166
	],
	"./filled/transporte.svg": [
		86476,
		86476
	],
	"./filled/twitter.svg": [
		63934,
		63934
	],
	"./filled/txt.svg": [
		30556,
		30556
	],
	"./filled/universitarios.svg": [
		32551,
		32551
	],
	"./filled/upload.svg": [
		53671,
		53671
	],
	"./filled/usuario.svg": [
		32730,
		32730
	],
	"./filled/veiculo.svg": [
		94295,
		94295
	],
	"./filled/venda.svg": [
		85914,
		85914
	],
	"./filled/vestuario.svg": [
		40214,
		40214
	],
	"./filled/vida-sustentavel.svg": [
		4256,
		4256
	],
	"./filled/vida.svg": [
		35870,
		35870
	],
	"./filled/video.svg": [
		68686,
		68686
	],
	"./filled/word.svg": [
		79888,
		79888
	],
	"./filled/xicara.svg": [
		88350,
		88350
	],
	"./likert/bad.svg": [
		67374,
		67374
	],
	"./likert/dislike.svg": [
		90646,
		90646
	],
	"./likert/idk.svg": [
		58157,
		58157
	],
	"./likert/like.svg": [
		78,
		78
	],
	"./likert/loved.svg": [
		38145,
		38145
	],
	"./outlined/acoes-grafico.svg": [
		77242,
		77242
	],
	"./outlined/acoes.svg": [
		50590,
		50590
	],
	"./outlined/adicionar.svg": [
		33287,
		33287
	],
	"./outlined/agencia-personalite.svg": [
		83927,
		83927
	],
	"./outlined/agencia.svg": [
		4171,
		4171
	],
	"./outlined/agil.svg": [
		85738,
		85738
	],
	"./outlined/ajuda.svg": [
		77894,
		77894
	],
	"./outlined/alimentacao.svg": [
		65951,
		65951
	],
	"./outlined/alvo.svg": [
		52389,
		52389
	],
	"./outlined/antecipacao-de-recebimento.svg": [
		57673,
		57673
	],
	"./outlined/aplicativos.svg": [
		82854,
		82854
	],
	"./outlined/aporte-de-capital.svg": [
		95439,
		95439
	],
	"./outlined/ar_condicionado.svg": [
		25928,
		25928
	],
	"./outlined/armario.svg": [
		14204,
		14204
	],
	"./outlined/arroba.svg": [
		63250,
		63250
	],
	"./outlined/assessoria.svg": [
		92775,
		92775
	],
	"./outlined/atendimento-telefonico.svg": [
		29579,
		29579
	],
	"./outlined/atendimento.svg": [
		97613,
		97613
	],
	"./outlined/atualizando.svg": [
		49681,
		49681
	],
	"./outlined/autoriza-pelo-celular.svg": [
		42243,
		42243
	],
	"./outlined/aviso.svg": [
		22422,
		22422
	],
	"./outlined/banco-de-caixa.svg": [
		33126,
		33126
	],
	"./outlined/beleza.svg": [
		19987,
		19987
	],
	"./outlined/beneficios.svg": [
		60580,
		60580
	],
	"./outlined/bike.svg": [
		62752,
		9606
	],
	"./outlined/biometria-facial.svg": [
		67874,
		67874
	],
	"./outlined/biometria.svg": [
		68482,
		68482
	],
	"./outlined/bomba-gas.svg": [
		3395,
		3395
	],
	"./outlined/brilho-nos-olhos.svg": [
		72981,
		72981
	],
	"./outlined/busca.svg": [
		94169,
		94169
	],
	"./outlined/cadastro-positivo.svg": [
		76822,
		76822
	],
	"./outlined/caixa-eletronico.svg": [
		42426,
		42426
	],
	"./outlined/caixas-exclusivos.svg": [
		76888,
		76888
	],
	"./outlined/calculadora.svg": [
		79064,
		79064
	],
	"./outlined/calendario.svg": [
		14825,
		14825
	],
	"./outlined/cambio.svg": [
		26401,
		26401
	],
	"./outlined/caminhao.svg": [
		28641,
		28641
	],
	"./outlined/caminhonete.svg": [
		60999,
		60999
	],
	"./outlined/cancela.svg": [
		31658,
		31658
	],
	"./outlined/carrinho.svg": [
		14052,
		14052
	],
	"./outlined/cartao-de-seguranca.svg": [
		92197,
		92197
	],
	"./outlined/cartao.svg": [
		77142,
		77142
	],
	"./outlined/carteira-digital.svg": [
		22316,
		22316
	],
	"./outlined/carteirada.svg": [
		69294,
		69294
	],
	"./outlined/carteiras-digitais.svg": [
		3086,
		3086
	],
	"./outlined/cartoes.svg": [
		95347,
		95347
	],
	"./outlined/celular-card.svg": [
		37238,
		37238
	],
	"./outlined/celular-pre-pago.svg": [
		91954,
		91954
	],
	"./outlined/celular.svg": [
		24151,
		24151
	],
	"./outlined/chat-aguardando.svg": [
		28717,
		28717
	],
	"./outlined/chat-entregue.svg": [
		97008,
		97008
	],
	"./outlined/chat-enviado.svg": [
		60814,
		60814
	],
	"./outlined/chat-erro.svg": [
		98741,
		98741
	],
	"./outlined/chave.svg": [
		36565,
		36565
	],
	"./outlined/check.svg": [
		8678
	],
	"./outlined/checkbox-indeterminado.svg": [
		98642,
		98642
	],
	"./outlined/checkbox-vazio.svg": [
		88154,
		88154
	],
	"./outlined/checkbox.svg": [
		69518,
		69518
	],
	"./outlined/cheque.svg": [
		83441,
		83441
	],
	"./outlined/chip.svg": [
		43437,
		43437
	],
	"./outlined/cifrao.svg": [
		72480,
		72480
	],
	"./outlined/cinema.svg": [
		62248,
		62248
	],
	"./outlined/cobranca.svg": [
		11712,
		11712
	],
	"./outlined/codigo-de-barras.svg": [
		34089,
		34089
	],
	"./outlined/coleta.svg": [
		12491,
		12491
	],
	"./outlined/compartilhar.svg": [
		20794,
		20794
	],
	"./outlined/compra.svg": [
		9031,
		9031
	],
	"./outlined/compras.svg": [
		463,
		463
	],
	"./outlined/comprovante.svg": [
		7095,
		7095
	],
	"./outlined/computador.svg": [
		18787,
		18787
	],
	"./outlined/conectcar-adesivo.svg": [
		40572,
		40572
	],
	"./outlined/conectcar.svg": [
		32412,
		38106
	],
	"./outlined/configuracao.svg": [
		74039,
		74039
	],
	"./outlined/confirmacao.svg": [
		62870
	],
	"./outlined/cons-investimento.svg": [
		54587,
		54587
	],
	"./outlined/cons-investimentos.svg": [
		12824,
		12824
	],
	"./outlined/consorcio-auto.svg": [
		92164,
		92164
	],
	"./outlined/consorcio-imobiliario.svg": [
		57632,
		57632
	],
	"./outlined/consorcio.svg": [
		95210,
		95210
	],
	"./outlined/conta-corrente.svg": [
		88261,
		88261
	],
	"./outlined/contatos.svg": [
		15145,
		15145
	],
	"./outlined/conti-negocios.svg": [
		5457,
		5457
	],
	"./outlined/contraste-off.svg": [
		83024,
		83024
	],
	"./outlined/contraste-on.svg": [
		25842,
		25842
	],
	"./outlined/copiar.svg": [
		95555
	],
	"./outlined/coracao.svg": [
		63559,
		63559
	],
	"./outlined/craques.svg": [
		40621,
		40621
	],
	"./outlined/credito-auto.svg": [
		77893,
		77893
	],
	"./outlined/credito-automatico.svg": [
		177,
		177
	],
	"./outlined/credito-consignado.svg": [
		85043,
		85043
	],
	"./outlined/credito-imobiliario.svg": [
		61258,
		61258
	],
	"./outlined/credito-sob-medida.svg": [
		96248,
		96248
	],
	"./outlined/credito.svg": [
		38344,
		38344
	],
	"./outlined/csv.svg": [
		19660,
		19660
	],
	"./outlined/cultura.svg": [
		71777,
		71777
	],
	"./outlined/curtir.svg": [
		43553,
		43553
	],
	"./outlined/debito.svg": [
		47410,
		47410
	],
	"./outlined/dente.svg": [
		70593,
		70593
	],
	"./outlined/deposito.svg": [
		20189,
		20189
	],
	"./outlined/desafios.svg": [
		47617,
		47617
	],
	"./outlined/desbloqueio.svg": [
		80071,
		80071
	],
	"./outlined/descurtir.svg": [
		31048,
		31048
	],
	"./outlined/diario.svg": [
		30314,
		30314
	],
	"./outlined/documento.svg": [
		24122,
		24122
	],
	"./outlined/documentos-pasta.svg": [
		24266,
		24266
	],
	"./outlined/download.svg": [
		50462,
		50462
	],
	"./outlined/e-comercial.svg": [
		50168,
		50168
	],
	"./outlined/editar.svg": [
		79908,
		79908
	],
	"./outlined/email-resposta-rapida.svg": [
		65977,
		65977
	],
	"./outlined/empresas.svg": [
		38732,
		38732
	],
	"./outlined/emprestimo.svg": [
		27700,
		27700
	],
	"./outlined/enviar.svg": [
		78063,
		78063
	],
	"./outlined/esporte.svg": [
		39848,
		39848
	],
	"./outlined/euro.svg": [
		60287,
		60287
	],
	"./outlined/excel.svg": [
		33925,
		33925
	],
	"./outlined/excluir.svg": [
		55634,
		55634
	],
	"./outlined/extrato.svg": [
		33014,
		33014
	],
	"./outlined/facebook.svg": [
		86688,
		86688
	],
	"./outlined/faceid.svg": [
		97171,
		97171
	],
	"./outlined/fatura.svg": [
		42187,
		42187
	],
	"./outlined/favorito.svg": [
		46356,
		46356
	],
	"./outlined/fechar.svg": [
		36560
	],
	"./outlined/feedback.svg": [
		43916,
		43916
	],
	"./outlined/ferramentas.svg": [
		77602,
		77602
	],
	"./outlined/filtro.svg": [
		13148,
		13148
	],
	"./outlined/fingerprint.svg": [
		62783,
		62783
	],
	"./outlined/flash-desabilitado.svg": [
		99744,
		99744
	],
	"./outlined/flash-habilitado.svg": [
		59428,
		59428
	],
	"./outlined/futebol.svg": [
		30011,
		30011
	],
	"./outlined/garantia.svg": [
		5173,
		5173
	],
	"./outlined/gerenciador-de-vendas.svg": [
		51869,
		51869
	],
	"./outlined/gerente-dedicado.svg": [
		68714,
		68714
	],
	"./outlined/gerente.svg": [
		1099,
		1099
	],
	"./outlined/gestao-de-crises.svg": [
		83445,
		83445
	],
	"./outlined/globo.svg": [
		36801,
		36801
	],
	"./outlined/historico-de-rentabilidade.svg": [
		69110,
		69110
	],
	"./outlined/home.svg": [
		41480,
		41480
	],
	"./outlined/icarros.svg": [
		98927,
		98927
	],
	"./outlined/imposto-de-renda.svg": [
		86273,
		86273
	],
	"./outlined/impressora.svg": [
		17296,
		17296
	],
	"./outlined/informação.svg": [
		52924,
		52924
	],
	"./outlined/inovacao.svg": [
		86551,
		86551
	],
	"./outlined/inss.svg": [
		55502,
		55502
	],
	"./outlined/instagram.svg": [
		23319,
		23319
	],
	"./outlined/institucional.svg": [
		43814,
		43814
	],
	"./outlined/investimento.svg": [
		97567,
		97567
	],
	"./outlined/iso.svg": [
		38459,
		38459
	],
	"./outlined/itaupass.svg": [
		49663,
		49663
	],
	"./outlined/itoken-chaveiro-1.svg": [
		49002,
		49002
	],
	"./outlined/itoken-chaveiro.svg": [
		36940,
		36940
	],
	"./outlined/itoken.svg": [
		87578,
		87578
	],
	"./outlined/jornal.svg": [
		12410,
		12410
	],
	"./outlined/juros.svg": [
		11553,
		11553
	],
	"./outlined/lavagem-de-dinheiro.svg": [
		96089,
		96089
	],
	"./outlined/lideranca.svg": [
		48411,
		48411
	],
	"./outlined/limite.svg": [
		94533,
		94533
	],
	"./outlined/link-externo.svg": [
		28077,
		28077
	],
	"./outlined/loja.svg": [
		12419,
		12419
	],
	"./outlined/maioires-limites-alt.svg": [
		17931,
		17931
	],
	"./outlined/maiores-limites.svg": [
		74985,
		74985
	],
	"./outlined/mais.svg": [
		84558
	],
	"./outlined/mala.svg": [
		66588,
		66588
	],
	"./outlined/maquina-cartao.svg": [
		81925,
		81925
	],
	"./outlined/maquina-fotografica.svg": [
		72165,
		72165
	],
	"./outlined/maquina-pos.svg": [
		23032,
		23032
	],
	"./outlined/maximizar.svg": [
		90855,
		90855
	],
	"./outlined/menos.svg": [
		52623,
		52623
	],
	"./outlined/menu-hamburger.svg": [
		27759,
		27759
	],
	"./outlined/metro.svg": [
		74290,
		74290
	],
	"./outlined/microfone.svg": [
		68179,
		68179
	],
	"./outlined/moto.svg": [
		35348,
		35348
	],
	"./outlined/nfc.svg": [
		42519,
		42519
	],
	"./outlined/notificacao.svg": [
		2850,
		2850
	],
	"./outlined/olho-ativo.svg": [
		67479,
		67479
	],
	"./outlined/olho-inativo.svg": [
		42718,
		42718
	],
	"./outlined/onibus.svg": [
		88597,
		88597
	],
	"./outlined/open-finance.svg": [
		99241,
		99241
	],
	"./outlined/ordenar-crescente.svg": [
		9657,
		69229
	],
	"./outlined/ordenar-decrescente.svg": [
		78145,
		78145
	],
	"./outlined/ordenar-direita.svg": [
		82798,
		82798
	],
	"./outlined/ordenar-esquerda.svg": [
		78040,
		78040
	],
	"./outlined/ordenar.svg": [
		95012,
		95012
	],
	"./outlined/orientacao-de-credito.svg": [
		64224,
		64224
	],
	"./outlined/outros.svg": [
		48759,
		41292
	],
	"./outlined/pagamento-ao-fornecedor.svg": [
		55729,
		55729
	],
	"./outlined/pagamentos.svg": [
		92002,
		92002
	],
	"./outlined/paixao.svg": [
		87500,
		87500
	],
	"./outlined/parcelamento.svg": [
		20376,
		20376
	],
	"./outlined/pdf.svg": [
		41414,
		41414
	],
	"./outlined/perfil-do-investidor.svg": [
		27314,
		27314
	],
	"./outlined/pers-conta.svg": [
		27199,
		27199
	],
	"./outlined/pet.svg": [
		91516,
		91516
	],
	"./outlined/pix.svg": [
		14723,
		14723
	],
	"./outlined/play.svg": [
		7849,
		7849
	],
	"./outlined/porcentagem.svg": [
		16271,
		16271
	],
	"./outlined/portabilidade.svg": [
		96402,
		96402
	],
	"./outlined/poupanca.svg": [
		17735,
		17735
	],
	"./outlined/predio.svg": [
		38352,
		38352
	],
	"./outlined/premio.svg": [
		59389,
		59389
	],
	"./outlined/presente.svg": [
		88866,
		88866
	],
	"./outlined/prevencao-de-fraude.svg": [
		9206,
		9206
	],
	"./outlined/previdencia.svg": [
		74120,
		74120
	],
	"./outlined/processos.svg": [
		11357,
		11357
	],
	"./outlined/produtos.svg": [
		1593,
		1593
	],
	"./outlined/programa-de-pontos.svg": [
		18469,
		18469
	],
	"./outlined/proibido-fumar.svg": [
		2204,
		2204
	],
	"./outlined/projeto-sucessorio.svg": [
		33414,
		33414
	],
	"./outlined/qrcode.svg": [
		2254,
		2254
	],
	"./outlined/radio-button.svg": [
		91573,
		91573
	],
	"./outlined/radio.svg": [
		14332,
		14332
	],
	"./outlined/recarga.svg": [
		64636,
		64636
	],
	"./outlined/recarregar.svg": [
		75549,
		75549
	],
	"./outlined/refresh.svg": [
		18962,
		18962
	],
	"./outlined/relatorios-financeiros.svg": [
		21129,
		21129
	],
	"./outlined/relogio.svg": [
		15381,
		15381
	],
	"./outlined/resgate.svg": [
		58411,
		58411
	],
	"./outlined/responder.svg": [
		20122,
		20122
	],
	"./outlined/responsabilidade-social.svg": [
		20539,
		20539
	],
	"./outlined/resposta.svg": [
		49468,
		49468
	],
	"./outlined/restaurar.svg": [
		73653,
		73653
	],
	"./outlined/sacola.svg": [
		28642,
		28642
	],
	"./outlined/sair-do-vermelho.svg": [
		42508,
		42508
	],
	"./outlined/sair.svg": [
		68629,
		68629
	],
	"./outlined/salario.svg": [
		45114,
		45114
	],
	"./outlined/saldo.svg": [
		86233,
		86233
	],
	"./outlined/salvar.svg": [
		67682,
		67682
	],
	"./outlined/saque.svg": [
		88494,
		88494
	],
	"./outlined/saude.svg": [
		76014,
		76014
	],
	"./outlined/seguranca-da-informacao.svg": [
		33587,
		33587
	],
	"./outlined/seguranca-patrimonial.svg": [
		65330,
		65330
	],
	"./outlined/seguranca-redes-sociais.svg": [
		58839,
		58839
	],
	"./outlined/seguranca.svg": [
		55738,
		55738
	],
	"./outlined/seguro-auto.svg": [
		49429,
		49429
	],
	"./outlined/seguro-cartao.svg": [
		40099,
		40099
	],
	"./outlined/seguro-crianca.svg": [
		51699,
		51699
	],
	"./outlined/seguro-de-credito.svg": [
		10677,
		10677
	],
	"./outlined/seguro-empresas.svg": [
		48017,
		48017
	],
	"./outlined/seguro-fraude.svg": [
		7962,
		7962
	],
	"./outlined/seguro-mulher.svg": [
		21125,
		21125
	],
	"./outlined/seguro-patrimonial.svg": [
		74398,
		74398
	],
	"./outlined/seguro-pet.svg": [
		42585,
		42585
	],
	"./outlined/seguro-prestamista.svg": [
		71084,
		71084
	],
	"./outlined/seguro-renda.svg": [
		78752,
		78752
	],
	"./outlined/seguro-residencial.svg": [
		96208,
		96208
	],
	"./outlined/seguro-responsabilidade-social.svg": [
		50499,
		50499
	],
	"./outlined/seguro-transporte.svg": [
		31536,
		31536
	],
	"./outlined/seguro-viagem.svg": [
		95829,
		95829
	],
	"./outlined/seguro-vida.svg": [
		35195,
		35195
	],
	"./outlined/seguro.svg": [
		54876,
		54876
	],
	"./outlined/selecao-terceiros.svg": [
		42705,
		42705
	],
	"./outlined/sem-anuidade.svg": [
		96347,
		96347
	],
	"./outlined/senha-box.svg": [
		11730,
		11730
	],
	"./outlined/senha-circulo.svg": [
		35823,
		35823
	],
	"./outlined/seta-baixo-achatada.svg": [
		37150,
		37150
	],
	"./outlined/seta-baixo.svg": [
		65222
	],
	"./outlined/seta-cima-achatada.svg": [
		78762,
		78762
	],
	"./outlined/seta-cima.svg": [
		30457,
		30457
	],
	"./outlined/seta-direita.svg": [
		21602
	],
	"./outlined/seta-esquerda.svg": [
		6019,
		6019
	],
	"./outlined/sms-chat.svg": [
		25922,
		25922
	],
	"./outlined/sonho-grande.svg": [
		61470,
		61470
	],
	"./outlined/sorriso.svg": [
		70420,
		70420
	],
	"./outlined/suporte.svg": [
		30018,
		30018
	],
	"./outlined/sustentabilidade.svg": [
		16805,
		16805
	],
	"./outlined/swipe.svg": [
		77029,
		77029
	],
	"./outlined/switch.svg": [
		77717,
		77717
	],
	"./outlined/tablet.svg": [
		29866,
		29866
	],
	"./outlined/teatro.svg": [
		9933,
		9933
	],
	"./outlined/telefone.svg": [
		54120,
		54120
	],
	"./outlined/timeline.svg": [
		41032,
		41032
	],
	"./outlined/todos-pelo-cliente.svg": [
		35782,
		35782
	],
	"./outlined/tooltip.svg": [
		25869,
		25869
	],
	"./outlined/transferencia.svg": [
		84310,
		84310
	],
	"./outlined/transporte.svg": [
		31224,
		31224
	],
	"./outlined/tv.svg": [
		71158,
		71158
	],
	"./outlined/twitter.svg": [
		97264,
		97264
	],
	"./outlined/txt.svg": [
		28126,
		28126
	],
	"./outlined/universitarios.svg": [
		57185,
		57185
	],
	"./outlined/upload.svg": [
		88878,
		88878
	],
	"./outlined/user.svg": [
		6642
	],
	"./outlined/veiculo.svg": [
		93797,
		93797
	],
	"./outlined/venda.svg": [
		15111,
		15111
	],
	"./outlined/vestuario.svg": [
		41563,
		41563
	],
	"./outlined/viagem.svg": [
		68060,
		68060
	],
	"./outlined/vida-sustentavel.svg": [
		14397,
		14397
	],
	"./outlined/vida.svg": [
		99812,
		99812
	],
	"./outlined/video.svg": [
		2904,
		2904
	],
	"./outlined/whatsapp.svg": [
		8961,
		8961
	],
	"./outlined/wifi.svg": [
		26633,
		26633
	],
	"./outlined/word.svg": [
		3280,
		3280
	],
	"./outlined/xicara.svg": [
		29785,
		29785
	],
	"./up-arrow-orange.svg": [
		60717,
		60717
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 53572;
module.exports = webpackAsyncContext;